import React from "react";
import { 
  RealizationsSection,
  RealizationsHeader,
  RealizationsTitleTag,
  RealizationsTitle,
  RealizationsGrid,
  ProjectCard,
  CardOverlay,
  CardTag,
  CardTitle,
  CardDescription,
  CardLink,
  CompanyName,
  AppDevelopmentTitle,
  FilterContainer
} from "./Realizations.styles";
import { LinkIcon, ArrowRightIcon } from "../shared/icons";
import realization1 from "../../assets/realization1.jpg";
import realization2 from "../../assets/realization2.jpg";
import realization3 from "../../assets/realization3.jpg";
import realization4 from "../../assets/realization4.jpg";
import Button from "../Button";

const Realizations = () => {
  return (
    <RealizationsSection>
      <RealizationsHeader>
        <RealizationsTitleTag>Nos</RealizationsTitleTag>
        <RealizationsTitle>Dernières réalisations</RealizationsTitle>
      </RealizationsHeader>

      <RealizationsGrid>
        {/* Carte 1: Serena */}
        <ProjectCard image={realization1} color="#FF8C42" className="first-card">
          <CardOverlay className="first-overlay">
            
            <CardTitle>Serena</CardTitle>
            <CardDescription>A Network of 3D virtual worlds focused on social connection</CardDescription>
            <CardLink>
              <LinkIcon color="white" />
              WebsiteLink.com
            </CardLink>
          </CardOverlay>
        </ProjectCard>

        {/* Carte 2: Metaverse (Sneaker) */}
        <ProjectCard image={realization2} color="#5C6BC0" className="second-card">
          <CardOverlay className="second-overlay">
            <CardTitle>Metaverse</CardTitle>
            <CardDescription>A Network of 3D virtual worlds focused on social connection</CardDescription>
            <CardLink>
              <LinkIcon color="white" />
              WebsiteLink.com
            </CardLink>
          </CardOverlay>
        </ProjectCard>

        {/* Carte 3: App Development (Bleu foncé) */}
        <ProjectCard image={realization3} color="#000080" className="third-card">
          <CardOverlay isLarge={true} className="third-overlay"> 
            <CardTitle>Metaverse</CardTitle>
            <CardDescription>A Network of 3D virtual worlds focused on social connection</CardDescription>
            <CardLink>
              <LinkIcon color="white" />
              WebsiteLink.com
            </CardLink>
          </CardOverlay>
        </ProjectCard>

        {/* Carte 4: Totche (Bleu clair/Gris) */}
        <ProjectCard image={realization4} color="#5C6BC0" className="fourth-card">
          <CardOverlay className="fourth-overlay">
            <CardTitle>Totche</CardTitle>
            <CardDescription>A Network of 3D virtual worlds focused on social connection</CardDescription>
            <CardLink>
              <LinkIcon color="white" />
              WebsiteLink.com
            </CardLink>
          </CardOverlay>
        </ProjectCard>
      </RealizationsGrid>
      <FilterContainer>
        <Button 
          background="linear-gradient(135deg, #151542 0%, #2d2d78 100%)"
          color="#fff"
          hoverBackground="linear-gradient(135deg, #151542 0%, #2d2d78 100%)"
          style={{ 
            width: '12.1354vw', // 233px → 12.1354vw
            height: '3.6458vw', // 70px → 3.6458vw
            borderTopLeftRadius: '2.6042vw', // 50px → 2.6042vw
            borderTopRightRadius: '0.2604vw', // 5px → 0.2604vw
            borderBottomRightRadius: '2.6042vw', // 50px → 2.6042vw
            borderBottomLeftRadius: '0.2604vw', // 5px → 0.2604vw
            boxShadow: '0 0.2083vw 0.8333vw rgba(33, 33, 77, 0.3)',
            backdropFilter: 'blur(0.3125vw)',
            border: '0.0521vw solid rgba(255, 255, 255, 0.1)' // 1px → 0.0521vw
          }}
        >
          WEB & Design
        </Button>
        
        <Button 
          background="rgba(255, 255, 255, 0.9)"
          color="#222"
          hoverBackground="#f4f4fb"
          style={{ 
            width: '12.1354vw', // 233px → 12.1354vw
            height: '3.6458vw', // 70px → 3.6458vw
            borderTopLeftRadius: '2.6042vw', // 50px → 2.6042vw
            borderTopRightRadius: '0.2604vw', // 5px → 0.2604vw
            borderBottomRightRadius: '2.6042vw', // 50px → 2.6042vw
            borderBottomLeftRadius: '0.2604vw', // 5px → 0.2604vw
            boxShadow: 'inset 0 0 0 0.0521vw rgba(0, 0, 0, 0.05), 0 0.2083vw 0.5208vw rgba(0, 0, 0, 0.07)',
            backdropFilter: 'blur(0.3125vw)',
            border: '0.0521vw solid rgba(0, 0, 0, 0.1)' // 1px → 0.0521vw
          }}
        >
          Logo
        </Button>
        
        <Button 
          background="rgba(255, 255, 255, 0.9)"
          color="#222"
          hoverBackground="#f4f4fb"
          style={{ 
            width: '12.1354vw', // 233px → 12.1354vw
            height: '3.6458vw', // 70px → 3.6458vw
            borderTopLeftRadius: '2.6042vw', // 50px → 2.6042vw
            borderTopRightRadius: '0.2604vw', // 5px → 0.2604vw
            borderBottomRightRadius: '2.6042vw', // 50px → 2.6042vw
            borderBottomLeftRadius: '0.2604vw', // 5px → 0.2604vw
            boxShadow: 'inset 0 0 0 0.0521vw rgba(0, 0, 0, 0.05), 0 0.2083vw 0.5208vw rgba(0, 0, 0, 0.07)',
            backdropFilter: 'blur(0.3125vw)',
            border: '0.0521vw solid rgba(0, 0, 0, 0.1)' // 1px → 0.0521vw
          }}
        >
          Graphisme
        </Button>
        
        <Button 
          background="linear-gradient(135deg, #161642 0%, #29296a 100%)"
          color="#fff"
          hoverBackground="linear-gradient(135deg, #1e1e57 0%, #383896 100%)"
          style={{ 
            width: '15.625vw', // 300px → 15.625vw
            height: '3.6458vw', // 85px → 4.4271vw
            borderTopLeftRadius: '2.6042vw', // 50px → 2.6042vw
            borderTopRightRadius: '0.2604vw', // 5px → 0.2604vw
            borderBottomRightRadius: '2.6042vw', // 50px → 2.6042vw
            borderBottomLeftRadius: '0.2604vw', // 5px → 0.2604vw
            boxShadow: '0 0.5208vw 1.3021vw rgba(0, 0, 0, 0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5208vw',
            border: '0.0521vw solid rgba(255, 255, 255, 0.1)', // 1px → 0.0521vw
            marginLeft: 'auto' // Pousse ce bouton à droite
          }}
        >
          Tous Nos Projets 
          <ArrowRightIcon color="#fff" />
        </Button>
      </FilterContainer>
    </RealizationsSection>
  );
};

export default Realizations;